import { FormControl, TextField, InputAdornment, FormHelperText } from "@mui/material"
import { Add, Remove } from "@mui/icons-material"
import LightBlueIconButton from "../buttons/LightBlueIconButton"
import useInput from "../../../hooks/use_input"
import useAppStore from "../../../store/app"
import { useEffect } from "react"
import { calculateAge } from "../../../config/helpers"
import useTranslation from "hooks/use_translation"
import { useTheme } from "@mui/material/styles"

const HumanAge = () => {
  const id = "age"
  const updateFieldInputValue = useAppStore((state) => state.updateFieldInputValue)
  const birthday = useAppStore((state) => state.fields.birthday?.input_value)
  const { fields } = useTranslation()
  const theme = useTheme()

  useEffect(() => {
    if (birthday.length > 0) {
      const age = calculateAge(birthday)

      updateFieldInputValue(id, age)
    }
  }, [])

  const validate = (value) => {
    if (value === "") return fields?.required

    return ""
  }

  const { handleChange, inputValue, errorMessage, handleBlur } = useInput(id, validate)

  const handleIncrement = () => {
    let formattedValue

    formattedValue = parseInt(inputValue)

    if (!Number.isInteger(formattedValue)) {
      formattedValue = 0
    }

    updateFieldInputValue(id, formattedValue + 1)
  }

  const handleDecrement = () => {
    let formattedValue

    formattedValue = parseInt(inputValue)

    if (!Number.isInteger(formattedValue)) {
      formattedValue = 0
      updateFieldInputValue(id, formattedValue)
    } else {
      updateFieldInputValue(id, formattedValue - 1)
    }
  }

  const handleInputChange = (event) => {
    const newValue = parseInt(event.target.value, 10)

    const ageValue = isNaN(newValue) ? 0 : newValue

    if (ageValue > 120) return

    const modifiedEvent = {
      ...event,
      target: { ...event.target, value: ageValue },
    }

    handleChange(modifiedEvent)
  }

  const IncreaseAction = ({ position }) => (
    <InputAdornment position={position}>
      <LightBlueIconButton onClick={handleDecrement}>
        <Remove />
      </LightBlueIconButton>
    </InputAdornment>
  )

  const DecreaseAction = ({ position }) => (
    <InputAdornment position={position}>
      <LightBlueIconButton onClick={handleIncrement}>
        <Add />
      </LightBlueIconButton>
    </InputAdornment>
  )

  return (
    <FormControl fullWidth>
      <TextField
        type="number"
        fullWidth
        value={inputValue}
        onChange={handleInputChange}
        onBlur={handleBlur}
        inputProps={{ min: 0, style: { textAlign: "center" } }}
        variant="outlined"
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "16px",
            backgroundColor: "#FFF",
            height: 80,
            fontSize: 32,
            fontWeight: 500,
          },
        }}
        InputProps={{
          startAdornment:
            theme.direction === "rtl" ? (
              <DecreaseAction position="start" />
            ) : (
              <IncreaseAction position="start" />
            ),
          endAdornment:
            theme.direction === "rtl" ? (
              <IncreaseAction position="end" />
            ) : (
              <DecreaseAction position="end" />
            ),
        }}
      />
      <FormHelperText variant="body2" sx={{ textAlign: "center", fontWeight: 700 }}>
        {fields?.age_hint}
      </FormHelperText>
      <FormHelperText variant="body2">{errorMessage}</FormHelperText>
    </FormControl>
  )
}

export default HumanAge
